﻿export default class JoinAnalysisControl {
    constructor(action, resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl, modalWrapper) {
        this.action = action;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.modalWrapper = modalWrapper;
        this.elementId = 'map-action-' + this.classId + '-' + this.action.Id;
        this.joinAnalysisWrapper = 'join-analysis-wrapper-' + this.classId + '-' + this.action.Id;
        this.cancelJoinAnalysisId = 'cancel-join-analysis-' + this.classId + '-' + this.action.Id;
        this.saveJoinAnalysisId = 'save-join-analysis-' + this.classId + '-' + this.action.Id;
        this.joinAnalysisContainer = 'join-analysis-container-' + this.classId + '-' + this.action.Id;
        this.active = false;
    }

    init() {
        this.menuContainer.append(this._getActionButtonTemplate());
        document.getElementById(this.elementId).addEventListener('click', this._actionButtonClickHandler());
    }

    _actionButtonClickHandler() {
        return () => {
            if (this.active) {
                this._hidePanel();
            } else {
                this._showPanel();
            }
        };
    }

    _hidePanel() {
        $('#' + this.modalWrapper)[0].innerHTML = '';
        $('#' + this.elementId).removeClass('selected');
    }

    _showPanel() {
        $('#' + this.elementId).addClass('selected');
        $('#' + this.modalWrapper)[0].innerHTML = this._getJoinAnalysisTemplate();
        this._addEvents();
    }

    _addEvents() {
        $('#' + this.cancelJoinAnalysisId).on('click', () => {
            this._hidePanel();
        });

        $('#' + this.saveJoinAnalysisId).on('click', () => {
            this._executeJoin();
        });
        
        $('#first-source').kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return this.rootURL + 'Map/GetMapEntities?idMap=' + this.mapControl.mapId;
                        }
                    }
                }
            },
            change: (evt) => {
                let value = evt.sender.dataSource.data().find(row => { return row.Id == evt.sender.value() });
                let url = '';

                if (value.Id < 0) {
                    url = this.rootURL + 'extconn/getextfields?idExtEntity=' + Math.abs(value.Id);
                } else {
                    url = this.rootURL + 'entity/GetFieldsByEntityId?idEntity=' + value.Id;
                }

                $.ajax({
                    type: "GET",
                    url: url,
                    async: true,
                    contentType: "application/json; charset=utf-8",
                    success: (result) => {
                        if (value.Id < 0) {
                            result.forEach(item => {
                                item.FieldName = item.Name;
                            });
                        }

                        this._showFields(true, result);

                        var dataSource = new kendo.data.DataSource({
                            data: result
                        });

                        dataSource.read();
                        $('#first-source-fields').data('kendoComboBox').setDataSource(dataSource);
                        $('#first-source-fields').data('kendoComboBox').value(null);
                    }
                });
            }
        });

        $('#second-source').kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return this.rootURL + 'Map/GetMapEntities?idMap=' + this.mapControl.mapId;
                        }
                    }
                }
            },
            change: (evt) => {
                let value = evt.sender.dataSource.data().find(row => { return row.Id == evt.sender.value() });
                let url = '';

                if (value.Id < 0) {
                    url = this.rootURL + 'extconn/getextfields?idExtEntity=' + Math.abs(value.Id);
                } else {
                    url = this.rootURL + 'entity/GetFieldsByEntityId?idEntity=' + value.Id;
                }

                $.ajax({
                    type: "GET",
                    url: url,
                    async: true,
                    contentType: "application/json; charset=utf-8",
                    success: (result) => {
                        if (value.Id < 0) {
                            result.forEach(item => {
                                item.FieldName = item.Name;
                            });
                        }

                        this._showFields(false, result);

                        var dataSource = new kendo.data.DataSource({
                            data: result
                        });

                        dataSource.read();
                        $('#second-source-fields').data('kendoComboBox').setDataSource(dataSource);
                        $('#second-source-fields').data('kendoComboBox').value(null);
                    }
                });
            }
        });

        $('#first-source-fields').kendoComboBox({
            dataTextField: 'FieldName',
            dataValueField: 'Id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: [],
            change: (evt) => {

            }
        });

        $('#second-source-fields').kendoComboBox({
            dataTextField: 'FieldName',
            dataValueField: 'Id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: [],
            change: (evt) => {

            }
        });

        $('#join-type').kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: [{
                Id: "Left",
                Name: "Left"
            }, {
                Id: "Right",
                Name: "Right"
            }, {
                Id: "Inner",
                Name: "Inner"
            }, {
                Id: "Outer",
                Name: "Outer"
            }
            ]
        });

        $('#analysis-pk-field').kendoComboBox({
            dataTextField: 'FieldName',
            dataValueField: 'Id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: [],
            change: (evt) => {

            }
        });

        $('#analysis-geom-field').kendoComboBox({
            dataTextField: 'FieldName',
            dataValueField: 'Id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: [],
            change: (evt) => {

            }
        });

        $('#spatial-filter').kendoSwitch({
            messages: {
                checked: 'Da',
                unchecked: 'Nu'
            },
            checked: false
        });
    }

    _executeJoin() {
        let firstEntity = $('#first-source').data('kendoComboBox').dataSource.data().find(row => { return row.Id == $('#first-source').data('kendoComboBox').value() });
        let secondEntity = $('#second-source').data('kendoComboBox').dataSource.data().find(row => { return row.Id == $('#second-source').data('kendoComboBox').value() });

        let data = {
            AnalyseType: 'Complex',
            DataSource: {
                Joins: [{
                    JoinType: $('#join-type').data('kendoComboBox').value(),
                    RightDataSource: {
                        
                    },
                    JoinFields: {
					    LeftField: {},
                        RightField: {},
                        OperatorType: 'Equals'
				    }
                }]
            },
            OutputValues: [],
            LayerName: $('#analysis-name').val() == '' ? (firstEntity.Name + '-' + secondEntity.Name) : $('#analysis-name').val(),
            PkField: $('#analysis-pk-field').data('kendoComboBox').value(),
            GeomField: $('#analysis-geom-field').data('kendoComboBox').value(),
            BboxStrategy: $('#spatial-filter').data('kendoSwitch').check()
        }

        if (firstEntity.Id < 0) {
            data.DataSource.IdExtEntity = Math.abs(firstEntity.Id);
        }
        else {
            data.DataSource.IdEntity = firstEntity.Id;
        }

        data.DataSource.Key = firstEntity.Name;

        if (secondEntity.Id < 0) {
            data.DataSource.Joins[0].RightDataSource.IdExtEntity = Math.abs(secondEntity.Id);
        }
        else {
            data.DataSource.Joins[0].RightDataSource.IdEntity = secondEntity.Id;
        }

        data.DataSource.Joins[0].RightDataSource.Key = secondEntity.Name;

        data.DataSource.Joins[0].JoinFields.LeftField = {
            FieldName: $('#first-source-fields').data('kendoComboBox').dataSource.data().find(row => { return row.Id == $('#first-source-fields').data('kendoComboBox').value() }).FieldName
        };

        data.DataSource.Joins[0].JoinFields.RightField = {
            FieldName: $('#second-source-fields').data('kendoComboBox').dataSource.data().find(row => { return row.Id == $('#second-source-fields').data('kendoComboBox').value() }).FieldName
        };

        let firstTargetFields = $('#first-source-target-field-items input');

        for (let i = 0; i < firstTargetFields.length; i++) {
            let targetField = $(firstTargetFields[i]);

            if (targetField[0].checked) {
                let fieldDescription = $('#first-source-fields').data('kendoComboBox').dataSource.data().find(row => { return row.Id == targetField.attr('ref-id') });
                data.OutputValues.push({
                    OutputName: firstEntity.Name + '.' + fieldDescription.FieldName,
                    IdField: fieldDescription.Id,
                    Type: 'Field',
                    DataSourceKey: firstEntity.Name,
                    Srid: fieldDescription.Srid
                });
            }
        }

        let secondTargetFields = $('#second-source-target-field-items input');

        for (let i = 0; i < secondTargetFields.length; i++) {
            let targetField = $(secondTargetFields[i]);

            if (targetField[0].checked) {
                let fieldDescription = $('#second-source-fields').data('kendoComboBox').dataSource.data().find(row => { return row.Id == targetField.attr('ref-id') });
                data.OutputValues.push({
                    OutputName: secondEntity.Name + '.' + fieldDescription.FieldName,
                    IdField: fieldDescription.Id,
                    Type: 'Field',
                    DataSourceKey: secondEntity.Name,
                    Srid: fieldDescription.Srid
                });
            }
        }

        let analyses = {};

        if (sessionStorage.getItem('xp_analysis') != null) {
            analyses = JSON.parse(sessionStorage.getItem('xp_analysis'));
        }
        let analysesId = this._generateGuid();
        analyses[analysesId] = data;
        sessionStorage.setItem('xp_analysis', JSON.stringify(analyses));
        $event.notify('analysisAdded', { id: analysesId }, this, this.classId);
        this._hidePanel();
    }

    _showFields(isFirst, fields) {
        let template = `<div class="col-12 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">Campuri preluate din Sursa ` + (isFirst ? `1` : `2`) + `:</label>
                                            <div class="form-group" id="` + (isFirst ? `first-source-target-field-items` : `second-source-target-field-items`) + `">`;

        fields.forEach(x => {
            template += `<div class="form-row ml-1">
                <input class="target-field-items" type="checkbox" ref-id="` + x.Id + `" datasource="` + (isFirst ? 'first' : 'second') + `"/>
                <span class="ml-1">` + x.FieldName + `</span>
            </div>`;
        });

        template += `</div></div></div>`;

        if (isFirst) {
            $('#first-source-target-fields')[0].innerHTML = template;
        } else {
            $('#second-source-target-fields')[0].innerHTML = template;
        }

        $('.target-field-items').on('change', (evt) => {
            let items = $('.target-field-items');
            let dataSource = [];
            for (let i = 0; i < items.length; i++) {
                let fieldItem = items[i];

                if (fieldItem.checked) {
                    let id = $(fieldItem).attr('ref-id');
                    let ds = $(fieldItem).attr('datasource');
                    let field;
                    let source;
                    if (ds == 'first') {
                        source = $('#first-source').data('kendoComboBox').dataSource.data().find(row => { return row.Id == $('#first-source').data('kendoComboBox').value() });
                        let fieldVal = $('#first-source-fields').data('kendoComboBox').dataSource.data().find(row => { return row.Id == id; });
                        if (source.Id < 0) {
                            field = source.Name + '.' + fieldVal.Name;
                        } else {
                            field = source.Name + '.' + fieldVal.FieldName;
                        }
                    } else {
                        source = $('#second-source').data('kendoComboBox').dataSource.data().find(row => { return row.Id == $('#second-source').data('kendoComboBox').value() });
                        let fieldVal = $('#second-source-fields').data('kendoComboBox').dataSource.data().find(row => { return row.Id == id; });
                        if (source.Id < 0) {
                            field = source.Name + '.' + fieldVal.Name;
                        } else {
                            field = source.Name + '.' + fieldVal.FieldName;
                        }
                    }

                    dataSource.push({
                        Id: field,
                        FieldName: field
                    });
                }
            }

            var newDs = new kendo.data.DataSource({
                data: dataSource
            });

            newDs.read();
            $('#analysis-pk-field').data('kendoComboBox').setDataSource(newDs);
            $('#analysis-pk-field').data('kendoComboBox').value(null);
            $('#analysis-geom-field').data('kendoComboBox').setDataSource(newDs);
            $('#analysis-geom-field').data('kendoComboBox').value(null);
        });
    }

    _getActionButtonTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<li>
                            <a class="btn map-menu-item" id="` + this.elementId + `" title="` + this._getTitle() + `">
                                <i class="` + this.action.Icon + `"></i>
                            </a>
                        </li>`;
        return div.firstChild;
    }

    _getTitle() {
        if (this.action.Title != null && this.action.Title != '') {
            return this.action.Title;
        }

        return this.resourcesHandler.get('SubType_' + this.action.SubType);
    }

    _getJoinAnalysisTemplate() {
        return `<div class="general-settings-wrapper panel config-modal" id="` + this.joinAnalysisWrapper + `">
                    <div class="general-settings-panel panel-container">
                        <div class="panel-content pt-2 pl-0 pr-0 pb-0">
                            <div class="form-row general-settings-title-row m-0 col-12">
                                <label class="form-label general-settings-title ml-3">Analiza de tip Join</label>
                            </div>
                            <div class="form-row mb-0 pl-3 pr-3 pt-3" id="` + this.joinAnalysisContainer + `">
                                <div class="form-group col-6 mb-1">
                                    <div class="col-12 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">Sursa 1:</label>
                                            <input class="form-control" id="first-source">
                                        </div>
                                    </div>
                                    <div class="col-12 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">Campuri Sursa 1:</label>
                                            <input class="form-control" id="first-source-fields">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-6 mb-1">
                                    <div class="col-12 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">Sursa 2:</label>
                                            <input class="form-control" id="second-source">
                                        </div>
                                    </div>
                                    <div class="col-12 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">Campuri Sursa 2:</label>
                                            <input class="form-control" id="second-source-fields">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-12 mb-0">
                                    <div class="col-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">Tip Join:</label>
                                            <input class="form-control" id="join-type">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-6 mb-1" id="first-source-target-fields">
                                </div>
                                <div class="form-group col-6 mb-1" id="second-source-target-fields">
                                </div>
                                <div class="form-group col-12 mb-1 d-flex">
                                    <div class="col-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">Denumire Strat Rezultat:</label>
                                            <input class="form-control" type="text" id="analysis-name">
                                        </div>
                                    </div>
                                    <div class="col-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">Camp Id Strat Rezultat:</label>
                                            <input class="form-control" id="analysis-pk-field">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-12 mb-1 d-flex">
                                    <div class="col-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">Camp Geometrie Strat Rezultat:</label>
                                            <input class="form-control" id="analysis-geom-field">
                                        </div>
                                    </div>
                                    <div class="col-6 mb-3 align-content-center pt-4">
                                        <div class="form-group" style="display: flex; flex-direction: row-reverse; height: 1.2rem; justify-content: flex-end;">
                                            <label class="form-label ml-1">Filtru Spatial</label>
                                            <div id="spatial-filter"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right">
                            <button id="` + this.cancelJoinAnalysisId + `" class="btn btn-secondary ml-auto" title="` + this.resourcesHandler.get('CancelChanges') + `" type="button">` + this.resourcesHandler.get('Cancel') + `</button>
                            <button id="` + this.saveJoinAnalysisId + `" class="btn btn-primary ml-2" title="` + this.resourcesHandler.get('SaveChanges') + `" type="button">Executa</button>
                        </div>
                    </div>
                </div>`;
    }

    _generateGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}